import { FunctionComponent } from "react";
import { useParams } from "react-router-dom";

import { NativeList, Stack, Text } from "@bps/fluent-ui";
import { BpIdUserDto } from "@libs/api/gateways/bp-id/bp-id.dtos";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import { RepairFederatedUserAccountsButton } from "./RepairFederatedUserAccountsButton";

export interface UserBpIdIdentitesProps {
  bpUserDetails: BpIdUserDto;
}
export const UserBpIdIdentites: FunctionComponent<UserBpIdIdentitesProps> = ({
  bpUserDetails
}) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const identitiesForThisTenant = bpUserDetails?.signInIdentities.filter(x =>
    x.issuerAssignedId.startsWith(`PR\\Bp Premier Online\\${tenantId}`)
  );

  const { data: hasUserWritePermission } = usePermissionsCheckQuery(
    Permissions.PltBpidUserWrite
  );

  const needsRepair =
    hasUserWritePermission && identitiesForThisTenant?.length > 1;

  const Repair: FunctionComponent = () => (
    <Stack tokens={{ childrenGap: 8 }}>
      <Text>
        <b>Warning </b>
      </Text>
      <Text>
        This account has nore than one federated identity assigned for this
        tenant, which may cause login issues.
      </Text>
      <Text>Click 'repair' below to fix this issue.</Text>

      <Stack horizontal tokens={{ childrenGap: 8 }}>
        {needsRepair && (
          <RepairFederatedUserAccountsButton bpIdUserId={bpUserDetails.id} />
        )}
      </Stack>
    </Stack>
  );

  return (
    <>
      {needsRepair && <Repair />}
      <NativeList>
        {bpUserDetails.signInIdentities?.map(identity => (
          <li key={identity.issuerAssignedId}>
            <Text bold>{identity.signInType}</Text>:{" "}
            <Text>{identity.issuerAssignedId}</Text>
          </li>
        ))}
      </NativeList>
    </>
  );
};
